var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.total)?_c('div',{staticClass:"paypalmessage",attrs:{"data-pp-message":"","data-pp-style-layout":"text","data-pp-style-logo-type":"inline","data-pp-style-text-color":"black","data-pp-amount":_vm.total}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }